class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    const sectionsToRenderAlways = [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.drawer__content',
      }
    ];
    
    let allSectionsToRender =  sectionsToRenderAlways;
    
    const mainCartItems = document.getElementById('main-cart-items');
    
    if(mainCartItems) {
      const sectionsToRenderCart = [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-contents',
        },      
        {
          id: 'cart-live-region-text',
          section: 'cart-live-region-text',
          selector: '.shopify-section'
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-contents',
        }

      ];
      allSectionsToRender = [].concat(sectionsToRenderAlways,sectionsToRenderCart);
    }
    
    
    return allSectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
      
        theme.insurance();

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.querySelector('.cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateCart() {
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    this.classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
//     this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


document.addEventListener("DOMContentLoaded", (e) => {
  
  const cartTriggers = document.querySelectorAll('[data-drawer-trigger]');
  const cartDrawer = document.querySelector('[data-drawer-target]');
  const cartClosers = document.querySelectorAll('[data-drawer-close]');
  
  cartDrawer.classList.add('is-active');

  function openCartDrawer() {
    cartDrawer.classList.add('is-visible');
    document.querySelector('html').classList.add('overflow-hidden');
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('is-visible');
    document.querySelector('html').classList.remove('overflow-hidden');
  }

  function update_cart(element) {
    let new_quantity = parseInt(element.getAttribute("data-qty")),
        line_number = parseInt(element.getAttribute("data-line"));
  }
  
  
  
  document.addEventListener('click',(e) => {
    if(e.target && e.target.hasAttribute('data-drawer-trigger')) {
      e.preventDefault();
      openCartDrawer();
    }
    if(e.target && e.target.hasAttribute('data-drawer-close')) {
      e.preventDefault();
      closeCartDrawer();
    }
    
  });

});

class UpsellAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
	  const preOrder = event.target.getAttribute('data-variant-preorder');
      const variantId = event.target.getAttribute('data-variant-id');
      let props = '';
      if(preOrder != '') {
        props = {
          "Pre-Order": preOrder
        }
      }
      theme.addItem(variantId,1,props);
    });
  }
}

customElements.define('upsell-add-button', UpsellAddButton);